import ClientFlightInterface from '../../interfaces/client/Flight'

export const RECEIVE_FLIGHT = 'RECEIVE_FLIGHT'

export default (flight: ClientFlightInterface) => ({
  type: RECEIVE_FLIGHT,
  flight,
})
